var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "text-right mt-3" },
      [
        _vm.showRestartStatus
          ? _c("action-button", {
              staticClass: "outline-success btn-block-xs-only mr-3",
              attrs: { i: "fas fa-undo", text: "Regresar Estatus" },
              on: { click: _vm.restartEstatusHandler }
            })
          : _vm._e(),
        _vm.showRemoveFiles
          ? _c("action-button", {
              staticClass: "outline-danger btn-block-xs-only mr-3",
              attrs: {
                i: "fas fa-times-circle",
                text: "Eliminar Archivos de Pagos"
              },
              on: { click: _vm.removeFilesHandler }
            })
          : _vm._e()
      ],
      1
    ),
    _c("div", { staticClass: "container-fluid mx-0 px-0 w-100" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c(
          "div",
          { class: _vm.isThisJornalPaid ? "col-md-8" : "col-md-12" },
          [
            _c("section-title", {
              attrs: { "has-line": "", title: "Información de Jornal" }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "col-md-4 d-flex justify-content-md-end mb-4 mb-md-0"
          },
          [
            _vm.isThisJornalPaid
              ? [
                  _c("span", { staticClass: "d-flex align-items-center" }, [
                    _c(
                      "label",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal mb-0 mr-1"
                      },
                      [_vm._v(" Fecha Pagado: ")]
                    ),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("date")(_vm.value.paymentDate)))
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ]),
    _c("div", { staticClass: "bg-secondary-3 rounded p-2" }, [
      _c("div", { staticClass: "row mt-2 mb-3 pr-0 pr-md-5 pr-sm-0" }, [
        _c("div", { staticClass: "col col-sm col-6" }, [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-start align-items-start align-items-md-center item-items-sm-start"
            },
            [
              _c("icon-view", {
                staticClass: "icon-view-extended",
                attrs: {
                  icon: "fas fa-file-invoice-dollar mt-2",
                  "icon-background": "#FF7058",
                  "icon-color": "#fff",
                  "icon-size": "20px",
                  width: ""
                }
              }),
              _c("div", { staticClass: "justify-content-start" }, [
                _c(
                  "div",
                  { staticClass: "color-gray-6 font-14 font-weight-normal" },
                  [_vm._v(" Número de Jornal: ")]
                ),
                _c(
                  "div",
                  { staticClass: "color-black font-weight-bold font-16 mt-1" },
                  [_vm._v(" " + _vm._s(_vm.value.paymentJournalNumber) + " ")]
                )
              ])
            ],
            1
          )
        ]),
        _c(
          "div",
          {
            staticClass:
              "col col-sm col-6 d-flex justify-content-center align-items-start align-items-md-center align-items-sm-start"
          },
          [
            _c("custom-balloon", {
              staticClass:
                "w-40 mt-1 font-weight-bold font-16 custom-status-extended",
              attrs: {
                "background-color": `bg-${_vm.getStatusColor(
                  _vm.value.paymentJournalStatusId
                )}`,
                text: _vm.value.paymentJournalStatusName
              }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "col text-sm-left text-md-right pr-5 ml-5 pl-4 mt-3 mt-md-0 mt-sm-3"
          },
          [
            _c(
              "div",
              { staticClass: "color-secondary-6 font-14 font-weight-normal" },
              [_vm._v(" Fecha Creado: ")]
            ),
            _c("div", { staticClass: "color-black font-weight-bold font-16" }, [
              _vm._v(" " + _vm._s(_vm._f("date")(_vm.value.createDate)) + " ")
            ])
          ]
        )
      ]),
      _c(
        "div",
        {
          staticClass:
            "row mx-1 pr-0 pr-md-5 pr-sm-0 my-2 py-3 rounded bg-white"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "col col-sm col-6 text-left text-md-center text-sm-left"
            },
            [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v("Pagos:")]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "color-black font-weight-bold font-16 ml-n0 ml-md-n2 ml-sm-n0"
                },
                [_vm._v(" " + _vm._s(_vm.value.paymentCount) + " ")]
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "col col-sm col-6 text-left text-md-center text-sm-left"
            },
            [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v(" Procesado: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-16" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("price")(_vm.value.processedAmount)) +
                      " "
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "col col-sm col-6 text-left text-md-center text-sm-left mt-3 mt-md-0 mt-sm-3"
            },
            [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v(" Pendiente: ")]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "color-black font-weight-bold font-16 ml-n0 ml-md-n3 ml-sm-n0"
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("price")(_vm.value.pendingAmount)) + " "
                  )
                ]
              )
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "col col-sm col-6 text-left text-md-right text-sm-left pr-4 mt-3 mt-md-0 mt-sm-3"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "color-secondary-6 font-14 font-weight-normal pr-3 mr-2"
                },
                [_vm._v(" Total: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-16 mr-3" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("price")(_vm.value.paymentTotalAmount)) +
                      " "
                  )
                ]
              )
            ]
          )
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }